import React, { useEffect } from "react"
import { Route, Switch } from "react-router-dom"
import Loadable from "@bappweb/loadable"
import Header from "@smpu-web/globalmodules/header"
import Footer from "@smpu-web/globalmodules/footer"
import Landing from "./landing"
import Block from "@bappweb/block"
import { useAppSelector } from "../config/hook"
import { useTranslation } from "react-i18next"

const Main = () => {
  const routes = React.useMemo(
    () => ({
      Landing,
      Details: () => <Loadable loader={() => import("./details")} />,
      Viewer: () => <Loadable loader={() => import("./viewer")} />,
      // eslint-disable-next-line react/no-multi-comp
      NotFound: () => <Loadable loader={() => import("./not-found-404")} />
    }),
    []
  )

  const { t } = useTranslation()

  useEffect(() => {
    document.title = t("PageTitle")
  }, [t])

  const step4Response = useAppSelector((state) => state.step4.response)
  const isViewerPage = step4Response?.isViewerPage

  const className = isViewerPage ? "bapp-page-viewer" : "bapp-main"

  return (
    <>
      <Block type="main" className={className}>
      { !isViewerPage && <Header /> }
        <Switch>
          <Route exact path="/" component={routes.Landing} />
          <Route path ="/details/*" component={routes.Details} />
          <Route path="/viewer" component={routes.Viewer} />
          <Route component={routes.NotFound} />
        </Switch>
        { !isViewerPage && <Footer copyrightText={t("Copyright")}/> }
      </Block>
    </>
  )
}

export default Main
